import { firestoreDateParser } from '@pedix-workspace/utils';
import { ProductStock } from './stock.types';
import { withNestedConverter } from '@pedix-workspace/shared-models';

export const getProductStockConverter = withNestedConverter<ProductStock>({
  fromFirestore(snapshot) {
    const productStock = <ProductStock>snapshot.data();

    return <ProductStock>{
      ...productStock,
      id: snapshot.id,
      updated: firestoreDateParser(productStock.updated),
    };
  },
  toFirestore(productStock: ProductStock): ProductStock {
    return productStock;
  },
});
